/* eslint-disable */

/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdEmptyProps } from './type';
const props: TdEmptyProps = {
  /** 描述文字 */
  description: {
    type: String,
  },
  /** 图标名称。值为字符串表示图标名称，值为 `Object` 类型，表示透传至 `icon` */
  icon: {
    type: null,
  },
  /** 图片地址 */
  image: {
    type: String,
  },
};

export default props;
